export enum CustomerStatusEnum {
  ACTIVE = "a",
  INACTIVE = "i",
  DELETED = "x",
}

export type CustomerStatusTypes = `${CustomerStatusEnum}`;

export type CustomerPasswordChangedTypes = "t" | "f";
export enum CustomerPasswordChangedEnum {
  TRUE = "t",
  FALSE = "f",
}

export enum CustomerTypeEnum {
  CUSTOMER = "c",
  MANAGER = "m", // Gerente
  SALESPERSON = "s", // Prescritor
}

export type CustomerTypeTypes = `${CustomerTypeEnum}`;

export enum ManagementTypeEnums {
  CUSTOMER = "customer",
  TRACKING = "tracking",
  WEBHOOK = "webhook",
}

export type ManagementTypeTypes = `${ManagementTypeEnums}`;

export enum ManagementActionEnums {
  VIEW = "view",
  EDIT = "edit",
}

export type ManagementActionTypes = `${ManagementActionEnums}`;

export type IManagementActionAccessDTO = Partial<
  Record<ManagementActionTypes, boolean>
>;

export interface ICustomerStatusSelectDTO {
  status: CustomerStatusTypes;
  text: string;
}

export const customerStatusSelect: ICustomerStatusSelectDTO[] = [
  {
    status: CustomerStatusEnum.ACTIVE,
    text: "Ativo",
  },
  {
    status: CustomerStatusEnum.INACTIVE,
    text: "Inativo",
  },
  {
    status: CustomerStatusEnum.DELETED,
    text: "Deletado",
  },
];

export interface IManagerDTO {
  user: {
    id: number;
    language: string;
    login: string;
    name: string;
    status: "a" | "i" | "x" | "p";
    type: number;
    createdAt: Date;
    updatedAt: Date;
  };
}

export interface ICustomerAccessDTO {
  management: boolean;
  customer?: IManagementActionAccessDTO;
  tracking?: IManagementActionAccessDTO;
  webhook?: IManagementActionAccessDTO;
}

export interface ICustomerDTO {
  customer: {
    id: number;
    type: CustomerTypeTypes;
    email: string;
    name: string;
    document: string;
    documentType: string | null;
    documentTypeData: any | null;
    status: string;
    photos: object;
    access: ICustomerAccessDTO;
    pswdChanged: CustomerPasswordChangedTypes;
    createdAt: Date;
    updatedAt: Date;
  };
}

export interface ICustomerSalesmanDTO {
  id: number;
  type: CustomerTypeTypes;
  name: string;
  email: string;
  documentType: string | null;
  documentTypeData: any | null;
  status: CustomerStatusTypes;
  photos: object;
  createdAt: Date;
  updatedAt: Date;
}

export interface ICustomerPublicDTO {
  id: number;
  type: CustomerTypeTypes;
  name: string;
  documentType: string | null;
  documentTypeData: any | null;
  status: string;
  photos: object;
  createdAt: Date;
  updatedAt: Date;
}

export interface ICityDataDTO {
  id: number;
  state: number;
  name: string;
  code?: string; // Optional code property
}

export interface IStateDataDTO {
  id: number;
  country: number;
  name: string;
  iso: string;
}

export interface ICountryDataDTO {
  id: number;
  name: string;
  twoDigIso: string;
  threeDigIso: string;
  langCode: string;
}

export const hasManagementPermission = (
  access: ICustomerAccessDTO | undefined,
  type: ManagementTypeTypes,
  action: ManagementActionTypes = ManagementActionEnums.VIEW,
) => {
  if (!access?.management) return false;

  const typeAccess = access[type];
  if (!typeAccess) return false;

  return typeAccess[action] === true;
};

export const hasAnyManagementPermission = (
  access: ICustomerAccessDTO | undefined,
) => {
  if (!access?.management) return false;

  return Object.values(ManagementTypeEnums).some((type) =>
    hasManagementPermission(access, type, ManagementActionEnums.VIEW),
  );
};
